import React, { PropsWithChildren } from 'react';

import './index.scss';

export default function QueryCardChips({ children }: PropsWithChildren) {
  return <div className="query-card-chips">{children}</div>;
}
